/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useLocation } from 'react-router-dom'

import type { RoleMappingState } from './CreateOrEditRoleMapping/RoleMappingBody/types'

const getState: (stateMatch: string | null) => RoleMappingState | undefined = (
  stateMatch: string | null,
) => {
  if (stateMatch) {
    try {
      return JSON.parse(decodeURIComponent(stateMatch)) as RoleMappingState
    } catch (error) {
      console.error('Failed to parse state:', error)
      return undefined
    }
  }

  return undefined
}

export const useIdTokenAndStateFromHash = () => {
  const location = useLocation()
  const hash = location.hash.substring(1) // Remove the # symbol
  const params = new URLSearchParams(hash)

  const idToken = params.get('id_token')
  const stateParam = params.get('state')
  const error = params.get('error')
  const errorDescription = params.get('error_description')
  const state = getState(stateParam)

  return {
    idToken,
    state,
    error,
    errorDescription,
  }
}
